import { axios } from '../../../plugins/axios'

export default {
  namespaced: true,

  state: {
    habilidades: [],
  },

  getters: {
    getHabilidades: (state) => {
      return state.habilidades
    },
  },

  mutations: {
    SET_HABILIDADES(state, habilidades) {
      state.habilidades = habilidades
    },
  },

  actions: {
    fetchHabilidades: async function ({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/DesarrolloPolicial/habilidades')
        .then((response) => {
          commit('SET_HABILIDADES', response.data.data)
        })
        .catch((error) => console.log(error))
    },
  },
}
